export const REACTION_TYPES = ['like', 'love', 'funny', 'fire', 'hundred'] as const;

export type CommunityReactionType = (typeof REACTION_TYPES)[number];

export const REACTION_EMOJI: Record<CommunityReactionType, string> = {
  like: '👍',
  love: '❤️',
  funny: '😂',
  fire: '🔥',
  hundred: '💯',
};
